import { ACCOUNT_ROUTES } from "@/features/account/routes/account.routes";
import { FRIENDS_ROUTES } from "@/features/friend/routes/friend.routes";
import { GROUP_ROUTES } from "@/features/groups/routes/group.routes";
import { CLOUD_ROUTES } from "@/features/lib/routes/lib.routes";
import { NOTIFICATION_ROUTES } from "@/features/notification/routes/notification.routes";

export const ROUTE_LIST = [
  ...GROUP_ROUTES,
  ...ACCOUNT_ROUTES,
  ...CLOUD_ROUTES,
  ...FRIENDS_ROUTES,
  ...NOTIFICATION_ROUTES,
];
